import { EventStateManager } from "./EventStateManager";
import { EventSync, EventSyncInterface } from "./EventSync";
import { OptimisticEventSync } from "./OptimisticEventSync";
import { PollingListener } from "./utils/PollingListener";

export class PollingOptimisticEventStateSync<State, Event> {
  private pollingListener: PollingListener<void>;
  public optimisticEventSync: OptimisticEventSync<Event>;

  constructor(
    public readonly eventStateManager: EventStateManager<State, Event>,
    public readonly eventSyncAdapter: EventSyncInterface<Event>,
    public readonly pollingIntervalInMs: number,
    public readonly startTimestamp = 0,
    public readonly onUndoEvent?: (event: Event) => void
  ) {
    const eventSync = new EventSync<Event>(
      eventSyncAdapter,
      (event) => eventStateManager.receive(event),
      startTimestamp
    );
    this.optimisticEventSync = new OptimisticEventSync(eventSync, onUndoEvent);

    this.pollingListener = new PollingListener<void>(
      () => this.optimisticEventSync.getNewEvents(),
      pollingIntervalInMs
    );
  }
  start() {
    this.pollingListener.start();
  }

  async send(event: Event) {
    return this.optimisticEventSync.send(event);
  }

  getSyncStatus() {
    return this.optimisticEventSync.getSyncStatus();
  }
  get state() {
    return this.eventStateManager.state;
  }
  delete() {
    return this.optimisticEventSync.eventSync.syncInterface.delete();
  }
  get isUpToDate(): boolean {
    return this.optimisticEventSync.isUpToDate;
  }
}
